import { OebsConfigActionTypes, OebsConfigActions } from './oebs-config.actions';
import { IOebsConfig } from '../../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IOebsConfig | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: OebsConfigActions): State {
    switch (action.type) {

        case OebsConfigActionTypes.LoadOebsConfigState: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case OebsConfigActionTypes.LoadOebsConfigStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case OebsConfigActionTypes.LoadOebsConfigStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case OebsConfigActionTypes.OebsConfigScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;